import apiService from 'services/apiService';
const baseUrl = `${window._env_.MONITOR_API_DOMAIN}`;
export * from './creditRisk';
export * from './insights';
export * from './activities';
export * from './export';
export * from './conversations';
export * from './monitorInsights';
import queryString from 'query-string';

const getSnapshotLatest = (entityId) => {
  const url = `${baseUrl}/v1/entities/${entityId}/snapshots/latest`;
  return apiService.get(url);
};

const getCapitalReportPdf = (entityId, facilitySources) => {
  const url = `${baseUrl}/v1/entities/${entityId}/snapshots/latest/report?${queryString.stringify({
    facilitySources,
  })}`;
  return apiService.get(url, {
    responseType: 'blob',
    'Content-Type': 'application/pdf',
    'Content-Disposition': 'attachment; filename=capital-report.pdf',
  });
};

const getCapitalReportPdfByCompanyNumber = (companyNumber) => {
  const url = `${baseUrl}/v1/companies/${companyNumber}/snapshots/report`;
  return apiService.get(url, {
    responseType: 'blob',
    'Content-Type': 'application/pdf',
    'Content-Disposition': 'attachment; filename=capital-report.pdf',
  });
};

const getCapitalReportPdfByRelatedCompanyNumber = (companyNumber) => {
  const url = `${baseUrl}/v1/related-companies/${companyNumber}/snapshot/report`;
  return apiService.get(url, {
    responseType: 'blob',
    'Content-Type': 'application/pdf',
    'Content-Disposition': 'attachment; filename=capital-report.pdf',
  });
};

const getCompanySnapshot = (entityId) => {
  const url = `${baseUrl}/v1/related-companies/${entityId}/snapshot`;
  return apiService.get(url);
};

const postSnapshotGeneration = (entityId) => {
  const url = `${baseUrl}/v1/entities/${entityId}/snapshots`;
  return apiService.post(url, {});
};

export {
  getSnapshotLatest,
  postSnapshotGeneration,
  getCompanySnapshot,
  getCapitalReportPdf,
  getCapitalReportPdfByCompanyNumber,
  getCapitalReportPdfByRelatedCompanyNumber,
};
